<template>
  <!-- Pie de página en texto. Reemplaza a la imagen /static/img/pie_pagina.png,
       que además traía el logo; va sin logo a propósito. -->
  <footer class="landing-footer">
    <div class="ft-inner">
      <address class="ft-address">
        <span class="ft-strong">AV. SEBASTIÁN PIÑERA 1050</span>
        <span>OF. 201 LAS CONDES</span>
        <span class="ft-strong">REGIÓN METROPOLITANA / CHILE.</span>
        <a class="ft-link" href="mailto:contacto@somosteatro.cl">
          CONTACTO@SOMOSTEATRO.CL
        </a>
        <a class="ft-link ft-strong" href="tel:+56996997829">+56 9 9699 7829</a>
      </address>

      <div class="ft-about">
        <a class="ft-about-title ft-about-title-link" href="/quienes-somos/">
          QUIENES SOMOS
        </a>
        <a class="ft-about-link" href="/preguntas-frecuentes/">
          PREGUNTAS FRECUENTES
        </a>
        <a class="ft-about-link" href="/terminos-y-condiciones/">
          TÉRMINOS Y CONDICIONES
        </a>
        <p class="ft-copy">
          © DERECHOS DE SOMOS TEATRO. TODOS LOS DERECHOS RESERVADOS.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TeatroFooter",
};
</script>

<style scoped>
/* `.landing-footer` es global (teatro.css) y aporta el margin-top:auto que
   empuja el pie al fondo; acá sólo se arma el contenido. */
.ft-inner {
  width: 100%;
  max-width: 1080px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 24px 40px;
  padding: 26px 0 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.ft-address {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-style: normal;
  color: var(--color-theater-text);
  font-family: var(--font-family-heading);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.7px;
  line-height: 1.5;
}

.ft-strong {
  font-weight: 800;
}

.ft-link {
  color: inherit;
  text-decoration: none;
  width: fit-content;
}

.ft-link:hover {
  text-decoration: underline;
}

.ft-about {
  text-align: left;
  min-width: 250px;
}

.ft-about-title {
  display: inline-block;
  padding-bottom: 6px;
  border-bottom: 2px solid #c8102e;
  color: var(--color-theater-text);
  font-family: var(--font-family-heading);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
}

/* Ahora el título es el enlace a /quienes-somos/. */
.ft-about-title-link {
  text-decoration: none;
  transition: color 0.2s ease;
}

.ft-about-title-link:hover {
  color: #fff;
}

.ft-about-link {
  display: block;
  margin-top: 12px;
  color: var(--color-theater-text);
  text-decoration: none;
  font-family: var(--font-family-heading);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.9px;
  transition: opacity 0.2s ease;
}

.ft-about-link:hover {
  opacity: 0.75;
  text-decoration: underline;
}

.ft-copy {
  margin: 16px 0 0;
  color: var(--color-theater-text-muted);
  font-family: var(--font-family-heading);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.6px;
}

@media (max-width: 760px) {
  .ft-inner {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .ft-about {
    min-width: 0;
  }
}
</style>
